module.exports = __webpack_public_path__ + "images/Update.26edc5f5be1557782709d688bbd22718.svg";